export const LOADING = 'favorites.loadingDotDotDot';
export const DEFAULT = 'favorites.default';
export const CREATE = 'favorites.create';
export const CANCEL = 'favorites.cancel';
export const REMOVE = 'favorites.remove';
export const MOVE_TO = 'favorites.moveToDotDotDot';
export const MAKE_DEFAULT = 'favorites.makeDefault';
export const ADD_NEW_FOLDER = 'favorites.addNewFolder';
export const PLUS_NEW_FOLDER = 'favorites.plusNewFolder';
export const PROMPT_UNFAV = 'favorites.promptUnfavorite';
export const FOLDER_NAME = 'favorites.folderName';
export const ADDED_TO_FAVORITES = 'favorites.add.default';
export const EPISODE_ADDED_TO_FAVORITES = 'favorites.add.episode';
export const PODCAST_ADDED_TO_FAVORITES = 'favorites.add.podcast';
export const STATION_ADDED_TO_FAVORITES = 'favorites.add.station';
export const ADD_TO_FAVORITES_ERROR = 'favorites.add.default.error';
export const EPISODE_REMOVED_FROM_FAVORITES = 'favorites.remove.episode';
export const PODCAST_REMOVED_FROM_FAVORITES = 'favorites.remove.podcast';
export const STATION_REMOVED_FROM_FAVORITES = 'favorites.remove.station';
export const REMOVED_FROM_FAVORITES = 'favorites.remove.default';
export const REMOVE_FROM_FAVORITES_ERROR = 'favorites.remove.default.error';
